module.exports = __webpack_public_path__ + "media/images/front/columns_test_img_04-188244924a182f186969d69aab3bce97.png";